import React from "react";

class CustomerReviews extends React.Component {
  componentDidMount() {
    const $ = window.$;
    $(this.refs.reviews).owlCarousel({
      'items': 1,
      'loop': true,
      'autoPlay': 5000,
      'itemsDesktop': [1200, 1],
      'itemsTablet': [980, 1],
      'itemsMobile': [700, 1]
    });
  }
  render() {
    return (
        <section className="section review-seciton" style={{background: "#FFEAFD", padding: "100px 0"}}>
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="text-left review_title">
                  <h1 className="Title">Happy Customers,<br/>Happy Us.</h1>
                  <p>Some of the reviews from our customers.</p>
                </div>
              </div>

              <div className="col-lg-6">
                <div id="reviews-carousel" ref="reviews" className="owl-carousel owl-theme reviews">
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>We live on a semi-rural road that had no cable internet but started with DSL FROM the phone company. In the last five years though the speed went from 3 mb to barely 1 mb download speed, and they had no plans on fixing the problem. We tried satellite internet but our data allotment for high speed was sucked out in the first 3 days of the billing period, even without steaming, just email and web browsing, and after the first of the month we were back to super slow speeds. The satellite customer service couldnt’t explain or fix the issue, and their community help boards were full of complaints and failed solutions. Then we noticed the hotspot on our phones were faster, but were burning out our batteries. I stumbled across this, and it’s a dream come true! We already had a cell phone signal booster to help with our cell reception, and I’m sure that helps. But I’ve had this for two weeks now, and speed is still fast and streaming easy. Have the 50 gig/30 day promotional and have used 8 gigs, and that is with 4 hours streaming. (My math is 2 hours is close to 1 gig streaming.) The maximum data plan recharge is $50 for 50 gig or 30 Days, compared to satellite crap at $90 a month, and I’m in heaven!</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>Read-n-write</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>I used this hotspot for a fundraising event where we needed consistent wifi for card swipers to operate.<br/>This hotspot was very easy to set up and the customer service super responsive. It really was so simple. Plus the hotspot gave us great wifi that was strong and effective for the whole evening.
                            <br/><br/>
                            Would really recommend this hotspot if you need something small but very reliable.</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>Bethany C.</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>Found this on Amazon and it works fine I called the company a service representative help me connect and it's beautiful.</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>D. P4</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>I absolutely love this! I have purchased another one a while back and I can tell you Mightywifi is fabulous, and the techs are also amazing and always willing to answer any questions.<br/>Highly recommends.</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>Bree W.</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>Great product for service members overseas.</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>Chavette H.</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>Exactly as described and has worked so far.</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>Dawn M.</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>This hockey puck shaped WiFi device is exactly what I needed. I need data on my daily
                            commute in the US and when I travel abroad I want an easy and affordable way to keep in
                            touch via Facebook, email, maps etc. The Mighty device allows all of that and I don’t have
                            to worry about roaming charges outside the USA or getting a local data sim.<br/><br/>Phone
                            based customer service was friendly and efficient. Got me online in a matter of minutes.</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>Howard H.</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>Product arrived on time and I called customer service to activate and he explained
                            everything perfectly and got me set up to travel abroad.<br/><br/>Thank you Mighty Wifi</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>Travis B.</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>I love this portable wifi device. It's great for doing my homework and streaming videos.
                            So, far I have been able to get quality WiFi everywhere I've driven in Southern California.
                            I wish I would have found it sooner.</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>Cherish J.</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>This little hotspot works like a charm . Great for travel or when your Internet goes down at home. Since I work from home and need an Internet connection to do my job, this is my go-to backup plan for surprise outages.</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>Melody</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="col no-padding">
                      <div className="reviews reviews-style reviews-with-quotes mb-0">
                        <blockquote>
                          <p>The Mighty wifi is awesome. The fella that activated it was so helpful and setup was so
                            easy. I am not techie at all and I had it up and running in just a few minutes. We will be
                            using it when we travel in the rv.<br/>Thanks mighty wifi!!</p>
                        </blockquote>
                        <div className="custom-review">
                          <p>
                            <strong>Bill L.</strong>
                            <span className="stars reviews-color">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </span>
                            <span className="reviews-name">Amazon Reviewer</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
    );
  }
}

export default CustomerReviews;



// WEBPACK FOOTER //
// ./src/layout/CustomerReviews.js